import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, GraduationCap, Award, Shield } from 'lucide-react';
import { recognitions } from '../../data/mock';

const iconMap = { Trophy, GraduationCap, Award };

const CERT_BADGES = [
  { abbr: 'AWS', provider: 'AWS', name: 'Certified AI Practitioner', color: '#FF9900' },
  { abbr: 'AZ', provider: 'Microsoft Azure', name: 'Fundamentals (AZ-900)', color: '#0078D4' },
  { abbr: 'IBM', provider: 'IBM', name: 'AI Developer Professional', color: '#9B59B6' },
  { abbr: 'G', provider: 'Google', name: 'IT Automation with Python', color: '#34A853' },
];

const RecognitionsSection = () => {
  return (
    <section id="recognitions" className="py-24 relative z-10">
      <div className="container mx-auto px-6 lg:px-16">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="section-label block mb-4"
        >
          // 3× TOP AI VOICE
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-display text-3xl lg:text-4xl font-bold text-[#F0F4FF] mb-12"
        >
          Recognition
        </motion.h2>

        {/* Achievement cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {recognitions.map((rec, index) => {
            const Icon = iconMap[rec.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                className="glass-card glass-card-hover rounded-xl p-6 text-center"
              >
                <div
                  className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center"
                  style={{ background: `${rec.color}15` }}
                >
                  <Icon size={24} style={{ color: rec.color }} />
                </div>
                <h3 className="font-display font-semibold text-[#F0F4FF] mb-2">{rec.title}</h3>
                <p className="font-mono text-sm text-[#8892A4]">{rec.description}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Certifications strip */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="glass-card rounded-xl p-6"
        >
          <div className="flex items-center gap-2 mb-5">
            <Shield size={16} className="text-[#00D4FF]" />
            <span className="font-mono text-sm text-[#8892A4]">Certifications</span>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {CERT_BADGES.map((cert, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.35 + i * 0.08 }}
                className="flex items-center gap-3 px-4 py-3 rounded-xl cursor-default group transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.02)',
                  border: `1px solid rgba(255,255,255,0.06)`,
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.border = `1px solid ${cert.color}40`;
                  e.currentTarget.style.boxShadow = `0 0 16px ${cert.color}12`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.border = '1px solid rgba(255,255,255,0.06)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <span
                  className="w-9 h-9 rounded-lg flex items-center justify-center font-mono text-[10px] font-bold flex-shrink-0"
                  style={{ background: `${cert.color}18`, color: cert.color }}
                >
                  {cert.abbr}
                </span>
                <div className="min-w-0">
                  <p className="font-mono text-xs font-semibold truncate" style={{ color: cert.color }}>
                    {cert.provider}
                  </p>
                  <p className="font-mono text-[10px] text-[#5A6878] truncate">{cert.name}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RecognitionsSection;
